import { render, staticRenderFns } from "./ViewSettingsBrands.vue?vue&type=template&id=0e11a185&scoped=true&"
import script from "./ViewSettingsBrands.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsBrands.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsBrands.vue?vue&type=style&index=0&id=0e11a185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e11a185",
  null
  
)

export default component.exports